import { AuthModel } from './_models'
import { refreshSession } from './_requests'
import { createSessionRefresher, installSessionRefresh, sessionLostPath } from './sessionRefresh'

const AUTH_LOCAL_STORAGE_KEY = 'sm-auth'
const getAuth = (): AuthModel | undefined => {

  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {

  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json';
  axios.defaults.headers.Language = localStorage.getItem("language")
  axios.interceptors.request.use(
    (config: { headers: { Authorization: string } }) => {
      const auth = getAuth()
      if (auth && auth.api_token) {
        config.headers.Authorization = `${auth.api_token}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  // A 401 on any call is first answered with one silent refresh from the
  // HttpOnly cookie (ADR-0019); only a refused refresh ends the session.
  installSessionRefresh(axios, {
    apiUrl: process.env.REACT_APP_API_URL || '',
    refreshSession: createSessionRefresher({
      refresh: async () => (await refreshSession()).data?.api_token,
      getAuth,
      setAuth,
      removeAuth,
    }),
    onSessionLost: () => {
      const { pathname } = window.location
      if (pathname.startsWith('/auth')) return
      const target = sessionLostPath(pathname)
      if (pathname !== target) window.location.assign(target)
    },
  })
}

export { getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY }
